import React, { useCallback, useEffect, useState } from 'react';
import b_ from 'b_';
import './styles.scss';
import {Table, Typography} from 'antd';
import { engineStatusWorkersFetch } from '../../../Reducers/engineStatus';
import useTable from '../../../Utils/useTable';
import { UsergroupAddOutlined } from '@ant-design/icons';

const b = b_.lock('StatusTable');

function TableWorkers() {

  const {
    list,
    isLoading,
  } = useTable(state => state.engineStatus.workers, engineStatusWorkersFetch);

  const rowClassName = (record) => {
    if (record.name === 'TOTAL') {
      return 'highlighted-row';
    }
    return '';
  };

  const GetColumns = useCallback(() => {
    return [
        { 
          dataIndex: "name",
          title: "Group",
          align: "center",
          width: 100,
        },
        {
          dataIndex: "redeemAccs",
          title: "Redeem",
          align: "center",
          render: (accsCount) => (
                          <div className={b('col')}>
                          {accsCount}
                      </div>
          )},
          {
            dataIndex: "purchaseAccs",
            title: "Purchase",
            align: "center",
            render: (accsCount) => (
                            <div className={b('col')}>
                            {accsCount}
                        </div>
            )},
            {
              dataIndex: "prepareAccs",
              title: "Prepare",
              align: "center",
              render: (accsCount) => (
                              <div className={b('col')}>
                              {accsCount}
                          </div>
              )},
              {
                dataIndex: "prepArchiveAccs",
                title: "Prepare Archive",
                align: "center",
                render: (accsCount) => (
                                <div className={b('col')}>
                                {accsCount}
                            </div>
                )}
    ]
  }, [list])

  const [columns, setColumns] = useState(GetColumns());
  const [updatedList, setUpdatedList] = useState([]);

  useEffect(() => {
    setColumns(GetColumns())
}, [list, GetColumns])

useEffect(() => {
    const updatedList = 
      list.map((item) => {
        if (item.name !== 'ALL' && item.isCurrency) {
          const updatedItem = { ...item };
          updatedItem.redeemAccs = item.redeemAccs;
          updatedItem.purchaseAccs = item.purchaseAccs;
          updatedItem.prepareAccs = item.prepareAccs;
          updatedItem.prepArchiveAccs = item.prepArchiveAccs;
          return updatedItem;
        }
        return item;
      })
    
    setColumns(GetColumns());
    setUpdatedList(updatedList)
      
    const updatedSum = calculateSum(updatedList);
    setUpdatedList((prev) => [...prev, updatedSum]);
}, [list]);

const calculateSum = useCallback((listToUpdate) => {
  const sum = {
    name: 'TOTAL',
    redeemAccs: 0,
    purchaseAccs: 0,
    prepareAccs: 0,
    prepArchiveAccs: 0
  };

  listToUpdate.forEach(item => {
    if (item.name !== 'ALL') {
      sum.redeemAccs += item.redeemAccs;
      sum.purchaseAccs += item.purchaseAccs;
      sum.prepareAccs += item.prepareAccs;
      sum.redeemAccs += item.redeemAccs;
      sum.prepArchiveAccs += item.prepArchiveAccs;
    }
  });

  return sum;
}, [list]);

const filteredList = updatedList.filter(item => item.name !== 'ALL');


  return (
    <div className='TableWorkers'>
    <Typography.Title level={4}><UsergroupAddOutlined /> Enabled accounts</Typography.Title>
  <Table 
        rowKey="name"
        bordered
        className={b('table')}
        dataSource={filteredList}
        pagination={false}
        columns={columns}
        loading={isLoading}
        size="small"
        scroll={{ x: "max-content" }}
        rowClassName={rowClassName}
  />
  </div>
  );
}

export default TableWorkers;
